module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<input id=\'indicator-operation-value\' name=\'indicator[operation]\' type=\'hidden\' value=\'' +
((__t = ( operation )) == null ? '' : __t) +
'\'>\n<dt>\n    <label for="indicators-list">' +
((__t = ( i18next.t('glossary.indicators') )) == null ? '' : __t) +
'</label>\n</dt>\n<dd>\n    <select class=\'text\' id=\'indicators-list\'></select>\n</dd>\n\n<dt style="margin-top: 5px; text-align: right;">\n    <a id="set-advanced" style="cursor: pointer">' +
((__t = ( i18next.t('indicators.switch_to_advanced') )) == null ? '' : __t) +
'</a>\n</dt>\n';

}
return __p
}